__turbopack_context__.v({
  "className": "poppins_87b0a9c0-module__5F-xWW__className",
  "variable": "poppins_87b0a9c0-module__5F-xWW__variable",
});
